import { useState, useEffect } from 'react';
import { TeamService } from '../integrations/sqlserver/teamService';
import { Team, TeamFilters } from '../integrations/sqlserver/teamTypes';

export const useTeams = (filters?: TeamFilters) => {
  const [teams, setTeams] = useState<Team[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchTeams = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await TeamService.getTeams(filters);
      setTeams(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
      console.error('Error fetching teams:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTeams();
  }, [JSON.stringify(filters)]);

  const refresh = () => {
    fetchTeams();
  };

  return {
    teams,
    loading,
    error,
    refresh
  };
};

export const useTeam = (id: string | null) => {
  const [team, setTeam] = useState<Team | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchTeam = async () => {
    if (!id) {
      setTeam(null);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const data = await TeamService.getTeamById(id);
      setTeam(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
      console.error('Error fetching team:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTeam();
  }, [id]);

  const refresh = () => {
    fetchTeam();
  };

  return {
    team,
    loading,
    error,
    refresh
  };
};
